export default __webpack_public_path__ + "images/06dfdc439cd897e0aff755745c363fd5-streak2.jpg";